<template>
  <div id="email-body" class="email contatto" style="position:absolute;top:0;left:0;"  >

    <table cellmargin="0" cellspacing="0" width="800" align="center" border="0" style="border:none;"><tr><td>


      <table cellmargin="0" cellspacing="0" width="800" align="center"><tr> 
        <td width="100%">
          <a href="https://www.centrocongressibergamo.com" style="margin:10px 0 0 20px;"><img src="http://centrocongressibergamo.yota.it/20191123/images/head.png" style="height:240;border:none;"></a>
        </td>
      </tr></table>



      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td style="margin:40px 0;">
          Gentile {{contatto.nome }} {{contatto.cognome }}
          <br /><br />
          le confermiamo l’avvenuta iscrizione al convegno in oggetto.
          <br /><br />
          La preghiamo di portare questa conferma il giorno dell’evento.
          <br /><br />
             
          <br /><br />
           
          <br /><br />
          Data: 23 novembre 2019
          <br /><br />
          <!--
          Sede evento: Sala Conferenze Ordine dei Medici della provincia di Bergamo, Via Giacomo Manzu', 25, Bergamo
          <br /><br />
           -->
          <br /><br />
           
          <br /><br />
          Cordiali saluti.
          <br /><br />
          La Segreteria Organizzativa
          <br /><br />
           
          <br /><br />
          CENTRO CONGRESSI GIOVANNI XXIII
          <br /><br />
          <a href="mailto:eventi@centrocongressibergamo.com">eventi@centrocongressibergamo.com</a>
        <br /><br />
        tel. + 035 236435
<br /><br />
        <hr />


          <br /><br />
          Ecco i dati inseriti:
          <br />
          Nominativo: {{contatto.nome }} {{contatto.cognome }}
          <br />
          Codice Fiscale: {{contatto.codicefiscale}}
          <br />
          Email: {{contatto.email}}
          <br />
          Città: {{contatto.citta}}
          <br />
          Azienda: {{contatto.azienda}}
          <br />
          Crediti ECM: {{contatto.creditiecm}}
          <br />
          
        </td>    
      </tr></table>








  </td ></tr></table>
</div>
</template>

<script>
export default {
   props: ['contatto'],
   beforeDestroy: function(){
     console.log("VM DISTRUTTA")
   }
}
</script>
